module.exports = __webpack_public_path__ + "8ef154c0b5c80e739269cbe73e794279.svg";